import * as Sentry from '@sentry/browser';

import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() { }

  handleError(error) {

    if (error instanceof HttpErrorResponse) {
      Sentry.captureMessage(`${error.statusText} ${error.message}`);
    } else {
      Sentry.captureException(error.originalError || error);
    }
    throw error;
  }
}

export function errorHandlerFactory(): ErrorHandler {
  if (environment.production) {

    Sentry.init({
      dsn: 'https://95032ea6b4cd4bf89e1c86dd52a9ba8a@sentry.loccioni.com/14',
      environment: environment.name,
      release: environment.version
    });

    return new SentryErrorHandler();
  }

  // Disable event propagation
  Sentry.init({
    beforeSend(event) {
      return null;
    }
  });

  return new ErrorHandler();
}
